/* AirRO Water — runtime config.
   Auto-detects where the backend API lives so the SAME files work both on your
   computer (local dev) and on the VPS (production), with no edits needed:

   - Local dev  (opened at http://localhost:8765): talks to the API on :4000.
   - Production (opened at https://yourdomain.com): talks to the API on the
     SAME domain under /api/v1 (Nginx proxies it to the Node backend).

   To force a specific API URL, set window.AIRRO_API_BASE before this file runs. */
(function () {
  if (window.AIRRO_API_BASE) return;                       // explicit override wins
  var host = location.hostname;
  var isLocal = host === 'localhost' || host === '127.0.0.1' || host === '';
  window.AIRRO_API_BASE = isLocal
    ? 'http://localhost:4000/api/v1'                        // local dev backend
    : location.origin + '/api/v1';                         // same-origin in production
  // SITUS UJI COBA (baru.airrooffice.com — a copy of the live data, see deploy/setup-baru.sh): a small
  // fixed label on every screen and in the tab title, so nobody mistakes it for the live site.
  if (/^baru\./i.test(host)) {
    window.AIRRO_STAGING = true;
    try {
      document.title = 'UJI COBA · ' + document.title;
      var tag = document.createElement('div');
      tag.className = 'airro-staging';
      tag.setAttribute('role', 'note');
      tag.textContent = 'SITUS UJI COBA — data salinan, bukan data asli';
      tag.style.cssText = 'position:fixed;top:env(safe-area-inset-top,0);left:50%;transform:translateX(-50%);z-index:2147483000;'
        + 'pointer-events:none;background:#B45309;color:#fff;font:700 11px/1.6 system-ui,sans-serif;letter-spacing:.04em;'
        + 'padding:1px 10px 2px;border-radius:0 0 8px 8px;opacity:.94;white-space:nowrap';
      (document.body || document.documentElement).appendChild(tag);
    } catch (e) { /* a label only — never block the app */ }
  }
})();
